/**
 * Sample comparison rows -- shown on the Variance Matrix page as a
 * fallback when the real SSS/TRS fetches error out or return nothing
 * (e.g. while /schedules'/post-times' exact field names are still being
 * confirmed -- see useWipComparison.js). Shaped identically to what
 * computeComparisonRows() produces, so switching between sample and real
 * data doesn't touch any rendering code.
 */

export const sampleComparisonRows = [
  {
    id: 'sample-1',
    staffName: 'Sokha Chan',
    position: 'Senior Associate',
    clientName: 'ABC Bank Plc',
    engagementId: 'sample-eng-1',
    engagementName: 'ABC Bank FY26 Audit',
    scheduledHours: 120,
    actualHours: 128,
    hourVariance: 8,
    costVariance: 280,
    status: 'over_budget',
  },
  {
    id: 'sample-2',
    staffName: 'Dara Pich',
    position: 'Associate',
    clientName: 'Mekong Retail Group',
    engagementId: 'sample-eng-2',
    engagementName: 'Mekong Retail Group Audit',
    scheduledHours: 80,
    actualHours: 76,
    hourVariance: -4,
    costVariance: -100,
    status: 'on_track',
  },
  {
    id: 'sample-3',
    staffName: 'Vanna Sok',
    position: 'Manager',
    clientName: 'Golden Land Co.',
    engagementId: 'sample-eng-3',
    engagementName: 'Golden Land Interim Review',
    scheduledHours: 40,
    actualHours: 0,
    hourVariance: -40,
    costVariance: -1800,
    status: 'no_show',
  },
  {
    id: 'sample-4',
    staffName: 'Ratana Kim',
    position: 'Senior Associate',
    clientName: 'Angkor Beverages',
    engagementId: 'sample-eng-4',
    engagementName: 'Angkor Beverages Tax Advisory',
    scheduledHours: 0,
    actualHours: 12,
    hourVariance: 12,
    costVariance: 420,
    status: 'unscheduled',
  },
  {
    id: 'sample-5',
    staffName: 'Sopheak Ly',
    position: 'Partner',
    clientName: 'Riverside Hotels Ltd',
    engagementId: 'sample-eng-5',
    engagementName: 'Riverside Hotels Audit',
    scheduledHours: 60,
    actualHours: 61,
    hourVariance: 1,
    costVariance: 55,
    status: 'on_track',
  },
];
